// has-module.directive.ts
import {
  Directive,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core'
import { Subject, takeUntil } from 'rxjs'
import { ModuleAccessService } from '../services/module-access.service'

@Directive({ selector: '[appHasModule]' })
export class HasModuleDirective implements OnInit, OnDestroy {
  private moduleAccessService = inject(ModuleAccessService)
  private templateRef = inject(TemplateRef<any>)
  private viewContainer = inject(ViewContainerRef)
  private destroy$ = new Subject<void>()

  @Input() set appHasModule(moduleName: string) {
    this.moduleAccessService
      .hasModule(moduleName)
      .pipe(takeUntil(this.destroy$))
      .subscribe((hasAccess: boolean) => {
        this.viewContainer.clear()
        if (hasAccess) {
          setTimeout(() => {
            this.viewContainer.createEmbeddedView(this.templateRef)
          }, 0)
        }
      })
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
